export default __webpack_public_path__ + "static/media/circleFullTp.826947d1.svg";